import { cva } from 'class-variance-authority';

export const bottomBarVariants = cva(
  'fixed [&:has(div:empty)]:hidden bottom-0 inset-x-0 z-40 rounded-t-2xl p-4 md:hidden',
  {
    variants: {
      variant: {
        default: 'bg-bgPrimary',
        glassmorphism: 'bg-bgPrimary/10 backdrop-saturate-2 backdrop-blur-3xl',
      },
      align: {
        default: '',
        flex: 'flex items-center gap-1',
      },
    },
    defaultVariants: {
      variant: 'default',
      align: 'default',
    },
  },
);
